import React from "react";
import { Form } from "react-bootstrap";

interface IApprovalFilterToggle {
    checked: boolean;
    onChange: (checked: boolean) => void;
}

export const ApprovalFilterToggle = ({ checked, onChange }: IApprovalFilterToggle) => {
    return (
        <Form.Check
            type="switch"
            id="inventory-approval-filter"
            className="mb-2"
            label="Nur nicht freigegebene Positionen"
            checked={checked}
            onChange={(e: any) => onChange(e.target.checked)}
        />
    );
};

export default ApprovalFilterToggle;
